import { render, staticRenderFns } from "./spklu_ac.vue?vue&type=template&id=58832eb6&scoped=true&"
import script from "./spklu_ac.vue?vue&type=script&lang=js&"
export * from "./spklu_ac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58832eb6",
  null
  
)

export default component.exports